import type { WMenuTranslations } from "./pl";

export const de: WMenuTranslations = {
  ariaLabelFallback: "Menü",
  empty: "Keine Menüeinträge.",
};
